import { fetchGridData } from '@bingads-webui-campaign/overview-cards-common';

export function fetchGridTileData({
  entitySet,
  filter,
  options,
  getCardsConfig,
  p$DateRange,
  jsdata,
  dateUtil,
  permissions,
  campaignType,
}) {
  return p$DateRange.then(dateRange => fetchGridData({
    entitySet,
    dateRange,
    filter,
    options,
    jsdata,
    dateUtil,
    getCardsConfig,
    permissions,
    campaignType,
  }));
}
